import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { Product } from '@/types/product';

export const useCartProducts = (cartProductIds: string[]) => {
  return useQuery({
    queryKey: ['cart-products', cartProductIds],
    enabled: cartProductIds.length > 0,
    placeholderData: (prev) => prev,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('products')
        .select(`
          *,
          product_images (*),
          category:product_categories(*),
          subcategory:product_subcategories(*)
        `)
        .in('id', cartProductIds)
        .eq('is_active', true);

      if (error) {
        console.error('Error fetching products for cart:', error);
        return [];
      }

      return data as Product[];
    },
  });
};